import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateAccountFormComponent } from './create-account-form.component';
import { ContentLoaderModule } from '../../content-loader/content-loader.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
} from 'ng-recaptcha';
import { config } from '../../../../../environments/environment';
import { TosNoticeModule } from 'navigation/nav-shared/components/user-forms/tos-notice/tos-notice.module';

@NgModule({
  declarations: [CreateAccountFormComponent],
  imports: [
    CommonModule,
    ContentLoaderModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TosNoticeModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: config.recaptchaKey,
      } as RecaptchaSettings,
    },
  ],
  exports: [CreateAccountFormComponent],
})
export class CreateAccountFormModule {}
